import { BlankState } from "source/shared/components"

export default function ErrorState() {
  return (
    <BlankState.Root role="alert">
      <BlankState.Icon symbol="general#exclamation-triangle" />
      <BlankState.Content>
        <BlankState.Heading text="Error loading podcast" />
        <BlankState.Description text="Please try refreshing the page to try again." />
      </BlankState.Content>
      <BlankState.Button
        text="Refresh"
        onClick={() => window.location.reload()}
      />
    </BlankState.Root>
  )
}
